/**
 * Created by psherif on 21/03/16.
 */
'use strict';

angular.module('mobile-apps')
  .directive('fitToScrollHeight',function($timeout, $rootScope) {
    return {
      link: function (scope, elem, attrs) {

        elem.on('input change paste cut drop focus', autosize);

        function autosize(event, triggerEvent){
          var el = this;
            $timeout(function () {

				//console.log(el.parentElement.parentElement);
				var current = [
					el.offsetHeight,
					$(el).innerHeight()
				];

				$(el.parentElement.parentElement).css('height', $(el).css('height')); // set parent element height to constant height while text area height is being adjusted, to prevent list from trying to adapt to new height
              $(el).css('height', '32px'); // necessary to shrink the scrollheight properly

				//$(el.parentElement).css('height', el.parentElement.offsetHeight+'px');
				 /*console.log('offsetHeight : '+ current[0]);
				 console.log('innerheight : '+current[1]);
				 console.log('scrollheight : '+el.scrollHeight);*/

              var targetHeight = el.scrollHeight;
				$(el).css('height', targetHeight + 'px');
				$(el.parentElement.parentElement).css('height', ''); // remove parent height so that it adjusts to child height again

            }, 0);
          }

        elem.on('$destroy', function() {
          return elem.off('input change paste cut drop focus', autosize);
        });
		  $timeout(function()
		  {
			  autosize.apply(elem[0], [null, true]);
		  },0);
      }
    };
  });
